import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, styled, useTheme, useMediaQuery } from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  boxShadow: 3,
  width: '100%',
  height: '1000px', // Consider making height more responsive
  position: 'relative',
  overflow: 'hidden',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  [theme.breakpoints.down('sm')]: {
    height: 'auto', // Adjust height for small screens
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 2), // Less padding on small screens
  },
}));

function GetStartedCard() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledCard>
      <CardMedia
        component="img"
        image="/assets/Photo 3.jpg"
        alt="Background"
        sx={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'cover', 
          [theme.breakpoints.down('sm')]: {
            height: '50vh', // Adjust height on small screens to be more responsive
          },
        }}
      />
      <CardContent sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'common.black',
        position: 'absolute',
        top: 0,
        padding: isSmallScreen ? theme.spacing(2) : theme.spacing(4), // More padding on small screens
        [theme.breakpoints.down('sm')]: {
          top: '10%', // Adjust content position on small screens
        },
      }}>
        <Typography gutterBottom variant={isSmallScreen ? "h5" : "h4"} component="div">
          Ready to get started?
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Let’s Create A Motivated Consumer Experience!
        </Typography>
        <StyledButton variant="contained" size="large">
          BOOK A DEMO
        </StyledButton>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          Book A Demo
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Schedule a personalized walkthrough to review our solutions and platform.
        </Typography>
        {/* Other text sections */}
      </CardContent>
    </StyledCard>
  );
}

export default GetStartedCard;
